import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagina-nao-encontrada',
  templateUrl: './pagina-nao-encontrada.component.html',
  styleUrls: ['./pagina-nao-encontrada.component.scss']
})
export class PaginaNaoEncontradaComponent implements OnInit {

  constructor
    (
    private location: PlatformLocation,
    private router: Router
    ) {
    this.location.onPopState(() => {
      this.location.back();
    });

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/pagina-nao-encontrada/pagina-nao-encontrada.component.ts